module.exports = __webpack_public_path__ + "static/img/super-chat-pass.74cd970d.png";